<template>
  <div class="block stack">
    <div class="grid">
      <div>
        <label for="entity_type_id">{{ $t("Entity Type") }}</label>
        <div class="select">
          <select id="entity_type_id" v-model="entityTypeId" required>
            <option v-for="(value, key) in entityTypes" :key="key" :value="key">
              {{ value }}
            </option>
          </select>
          <app-icon svg="form-select"/>
        </div>
        <input type="hidden" name="entity_type_id" v-model="entityTypeId" />
        <input-error :messages="errors.entity_type_id" />
      </div>

      <div>
        <label for="vat">{{ $t("TIN") }}</label>
        <input id="vat" name="vat" v-model="vat" type="text" readonly/>
        <input-error :messages="errors?.vat" />
      </div>
    </div>

    <fieldset v-if="isCompany" class="stack">
    <legend>{{ $t("Company Details") }}</legend>
      <div class="grid">
        <div>
          <label for="legal_nature_id">{{ $t("Legal Nature") }}</label>
          <div class="select">
            <select id="legal_nature_id" v-model="legalNatureId">
              <option v-for="(value, key) in legalNatureTypes" :key="key" :value="key">
                {{ value }}
              </option>
            </select>
            <app-icon svg="form-select"/>
          </div>
          <input type="hidden" name="legal_nature_id" v-model="legalNatureId" />
          <input-error :messages="errors?.legal_nature_id" />
        </div>

        <div>
          <label for="cae">{{ $t("CAE") }}</label>
          <input name="cae" id="cae" v-model="cae" type="text" />
          <input-error :messages="errors?.cae" />
        </div>

        <div>
          <label for="share_capital">{{ $t("Share Capital") }}</label>
          <input id="share_capital" name="share_capital" v-model="shareCapital" type="number" />
          <input-error :messages="errors?.share_capital" />
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script setup>

import { ref, computed, watch, onMounted } from "vue";

import AppIcon from "@/components/AppIcon.vue";
import InputError from "@/components/InputError.vue";

const props = defineProps({
  isCompanyId: Number,
  entityTypes: Object,
  legalNatureTypes: Object,
  defaultValue: Object,
  errors: Object,
});

const entityTypeId = ref(props.defaultValue?.entity_type_id || "");
const vat = ref(props.defaultValue?.vat || "");
const legalNatureId = ref(props.defaultValue?.legal_nature_id || "");
const cae = ref(props.defaultValue?.cae || "");
const shareCapital = ref(props.defaultValue?.share_capital || "");

const isCompany = computed(() => entityTypeId.value == props.isCompanyId);

const dispatchEntityTypeChange = () => {
  window.dispatchEvent(new CustomEvent("entity-type-changed", {
    detail: { isCompany: isCompany.value },
  }));
};

onMounted(dispatchEntityTypeChange);
watch(entityTypeId, dispatchEntityTypeChange);

</script>
